import { render, staticRenderFns } from "./FileSearchResultConfiguration.vue?vue&type=template&id=2e13022a&"
import script from "./FileSearchResultConfiguration.vue?vue&type=script&lang=ts&"
export * from "./FileSearchResultConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports